import { getWPModuleSpacing } from "@app/api/wp-page-fetcher/utils/get-wp-module-spacing";
import { moduleMapperThrowMessage } from "@app/api/wp-page-fetcher/utils/module-mapper-error-handling";
import { IModuleFetcher } from "@app/api/wp-page-fetcher/module-selector/module-selector";
import { OutDealDTO, SearchApi } from "@app/bf-api";
import Logger from "@app/util/logger";
import { FeaturedDealsSearchModule } from "@app/api/modules/featured-deals-search/featured-deals-search.module";
import { combineFilters } from "@app/api/wp-page-fetcher/utils/combine-filters";

import { IWPFeaturedDealsSearchModuleFull } from "./featured-deals-search-module.interface";
import { mapDealsToFeaturedDeals } from "../featured-deals-module";
import { getWpLink } from "../featured-merchants-module";

const DEFAULT_AMOUNT_OF_DEALS = 9;

export interface IFeaturedDealsSearchModuleMapper extends IModuleFetcher {
  module: IWPFeaturedDealsSearchModuleFull;
}

export const featuredDealsSearchModuleMapper = async (
  props: IFeaturedDealsSearchModuleMapper
): Promise<FeaturedDealsSearchModule | undefined> => {
  try {
    const {
      module,
      module: { data },
      res,
      platformId,
      pageUrl
    } = props;

    if (!data || (!data.searchValue && !data.searchValueEAN && !data.brandSelection && !data.categorySelection))
      return moduleMapperThrowMessage("No data found in featuredDealsSearchModuleMapper");

    const filterIds = combineFilters([data.brandSelection, data.categorySelection]);

    let featuredDeals: OutDealDTO[] | undefined = [];

    if (res) {
      const api = new SearchApi();
      const result = await api.findAllEntitiesByFilters({
        platformId,
        skip: 0,
        take: data.amountOfDeals || DEFAULT_AMOUNT_OF_DEALS,
        modules: "deals",
        searchText: data.searchValue || undefined,
        searchEAN: data.searchValueEAN || undefined,
        filters: filterIds || undefined
      });
      featuredDeals = result.deals?.data;
    }

    return {
      id: "27",
      name: "FeaturedDealsSearchModule",
      ...getWPModuleSpacing(module.data, module.setMargins),
      background: { backgroundColour: data.bgColor },
      title: data.title || "",
      subtitle: data.subtitle || "",
      useSeeMoreCard: data.useSeeMoreCard,
      topCtaTitle: getWpLink(data.topCtaTitle),
      ctaButton: getWpLink(data.cta),
      ctaUnderButton: getWpLink(data.ctaUnderButton),
      ctaDescription: data.ctaDescription || "",
      searchValue: data.searchValue || undefined,
      searchValueEAN: data.searchValueEAN || undefined,
      amountOfDeals: data.amountOfDeals,
      featuredDeals: mapDealsToFeaturedDeals(featuredDeals || []),
      amountOfDealsMobile: data.amountOfDealsMobile,
      brandSelection: data?.brandSelection,
      categorySelection: data?.categorySelection,
      pageUrl
    };
  } catch (e) {
    Logger.logError(e, "Error in: featuredDealsSearchModuleMapper");

    return undefined;
  }
};
